<template>
  <div class="screen"></div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@use "@/styles/vars.scss" as *;
.screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1000;
  background-color: $grey;
  opacity: 0.4;
}
</style>